import React, { useMemo } from "react";
import { ContentCardProps } from "@companion-core/shared/app/Components/Cards/ContentCard/ContentCard.model";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { ImageCard } from "@companion-core/shared/app/Components/Cards/ImageCard/ImageCard";
import { Tags } from "@companion-core/shared/app/Components/Tags";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getResolvedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import "Assets/Styles/scss/contentCard.scss";

export const ContentCard = ({
  testID,
  type = "split",
  title,
  subtitle,
  imageUrl,
  imageAlt,
  logo,
  logoAlt,
  date,
  fixedHeight = false,
  iconOverlay,
  tags,
}: ContentCardProps) => {
  const isAllInOneCard = useMemo(() => type === "include", [type]);
  const hasTags = Boolean(tags?.length);

  return (
    <div
      data-testid={testID}
      className={`content-card ${
        isAllInOneCard
          ? "content-card--all-in-one"
          : fixedHeight
            ? "content-card--fixed-height"
            : ""
      }`}>
      <ImageCard
        testID={`${testID}__image-card`}
        className="content-card__content"
        imageUrl={imageUrl}
        imageAlt={imageAlt}
        iconOverlay={iconOverlay}
        allInOne={isAllInOneCard}>
        {isAllInOneCard ? (
          <div className="content-card__centered-information">
            <span data-testid={`${testID}__title`} className="content-card__title body-text-3">
              {title}
            </span>
            <span
              data-testid={`${testID}__subtitle`}
              className="content-card__subtitle body-text-6">
              {subtitle}
            </span>
          </div>
        ) : (
          <>
            {date && (
              <div className="content-card__pellet body-text-11">
                <FontIcon name="JP-Clock" size={10} />
                <span data-testid={`${testID}__pellet-text`} className="content-card__pellet-text">
                  {date}
                </span>
              </div>
            )}
            <div className="content-card__header">
              <div className="content-card__information">
                <span data-testid={`${testID}__title`} className="content-card__title body-text-5">
                  {title}
                </span>
                <span
                  data-testid={`${testID}__subtitle`}
                  className="content-card__subtitle body-text-6">
                  {subtitle}
                </span>
                {hasTags && (
                  <Tags tags={tags!} limit={2} clickable={false} className="content-card__tags" />
                )}
              </div>
              {logo && (
                <div data-testid={`${testID}__logo`} className="content-card__logo">
                  <img
                    src={getCloudinaryOptimizedUrl(logo, {
                      contentType: "logo",
                      width: window.innerWidth,
                    })}
                    alt={getResolvedDescriptionAlt(logoAlt, "Card logo")}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </ImageCard>
    </div>
  );
};
